import React, { Component } from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class SingleInputModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            inputValue: props.defaultValue || '',
            inputState: ''
        };
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <CustomInput
                        success={this.state.inputState === "success"}
                        error={this.state.inputState === "error"}
                        labelText={this.props.labelText}
                        id="account_no"
                        formControlProps={{
                            fullWidth: true,
                            disabled: this.props.disabled || this.props.loading
                        }}
                        labelProps={{ shrink: true, disabled: this.props.disabled || this.props.loading }}
                        inputProps={{
                            onChange: event => this.setState({ inputValue: event.target.value, inputState: Boolean(event.target.value) ? "success" : "error" }),
                            value: this.state.inputValue,
                            disabled: this.props.disabled || this.props.loading
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>
                    {
                        this.props.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.state.inputState === 'success' && this.props.onConfirm(this.state.inputValue)}
                                disabled={this.state.inputState !== 'success'}
                                color="rose"
                                round
                            >
                                &nbsp;
                                {this.props.confirmText}
                                &nbsp;&nbsp;
                                {
                                    this.props.confirmIcon ?
                                        <FontAwesomeIcon icon={this.props.confirmIcon} />
                                        :
                                        null
                                }
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(SingleInputModal);